// extracted by mini-css-extract-plugin
export var speaker = "style-module--speaker--d4d0a";
export var wrap = "style-module--wrap--f9ab2";